import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ProductsValuationDetailSummary } from '../../Models/Domains/Valuation/ProductsValuationDetailSummary';
import { AssetClassType } from '../../Constants/Enums/Domain/Instrument/AssetClassType';
import { IJsonDate } from '../../System/IJsonDate';

declare var IS_RUNNING_IN_APP_POOL;

export class NewProductsValuationDetailSummaryClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(headAccountHierarchyIds: Array<string>, subAccountHierarchyIds: Array<string>, assetClassType: AssetClassType, asAt: IJsonDate): Promise<ProductsValuationDetailSummary, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Transformation/NewProductsValuationDetailSummary/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { headAccountHierarchyIds: headAccountHierarchyIds, subAccountHierarchyIds: subAccountHierarchyIds, assetClassType: assetClassType, asAt: asAt }

    return AjaxWrapper.get<ProductsValuationDetailSummary, any>(url, data);
  }
}

